import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbdeef84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "appItem__iconBox" }
const _hoisted_2 = { style: {"text-align":"center"} }

import { NEllipsis, NImage } from 'naive-ui'
import defaultAppIcon from '../../../../assets/defaultAppIcon.svg'
import { NavApp } from '../../useNavApplication'

export default /*#__PURE__*/_defineComponent({
  __name: 'appItem',
  props: {
    isDraggling: { type: Boolean },
    appInfo: null,
    type: null,
    openAppLink: null,
    showAppOptions: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.type === 'vertical' ? 'appItemVertical' : 'appItemHorizontal'),
    onClick: _cache[0] || (_cache[0] = () => __props.openAppLink(__props.appInfo.appLink)),
    onContextmenu: _cache[1] || (_cache[1] = _withModifiers(e => __props.showAppOptions(e, __props.appInfo), ["prevent","stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(NImage), {
        src: __props.appInfo.appIcon || _unref(defaultAppIcon),
        alt: "appItem__icon",
        class: "appItem__icon"
      }, null, 8, ["src"])
    ]),
    _createVNode(_unref(NEllipsis), {
      class: "appItem__appName",
      tooltip: { placement: 'bottom', disabled: __props.isDraggling }
    }, {
      tooltip: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.appInfo.appName), 1)
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.appInfo.appName) + " ", 1)
      ]),
      _: 1
    }, 8, ["tooltip"])
  ], 34))
}
}

})